<template>
    <el-container class="temp-strategy">
        <el-header>
            <Header></Header>
        </el-header>
        <el-main>
            <div class="temp-strategy_title clearfloat">
                <span class="float-left">策略</span>
                <div class="temp-strategy_box_item float-right">

                    <el-dropdown trigger="click">
                        <el-button class="btn__style">操作 <i class="el-icon-caret-bottom"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleEvent">手动设置</el-dropdown-item>
                            <el-dropdown-item @click.native="editEvent">网格设置</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="temp-handle-board" v-show="showFlag">
                        
                        <el-form label-width="80px">
                            <el-form-item label="张数">
                                <el-input v-model="openNum" placeholder="开仓张数"></el-input>
                            </el-form-item>
                            <el-form-item label="开仓方向">
                                <el-select v-model="openType">
                                    <el-option label="okex开多, huobi开空" value="1"></el-option>
                                    <el-option label="okex开空, huobi开多" value="2"></el-option>
                                    <el-option label="okex平多, huobi平空" value="3"></el-option>
                                    <el-option label="okex平空, huobi平多" value="4"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <div class="temp-handle_tip" style="text-align: right;">
                            Tip：立即采用实时价格交易
                        </div>
                        <div class="handle-board_btn">
                            <el-button class="btn__style_white" @click="submitOpen">确认</el-button>
                            <el-button class="btn__style_white" @click="showFlag = false">取消</el-button>
                        </div>
                    </div>

                    <div class="temp-handle-board" v-show="editFlag">
                        <div class="temp-handle_tip">
                            Tip：价格以okex平台的现货价格做参照！
                            <div class="temp-handle_der_item" v-if="tempData.direction_ratio == 1">
                                <p>价格涨过上线价：ok开多，火币开空; 价格跌破下线价：ok开空，火币开多</p>
                            </div>
                            <div class="temp-handle_der_item" v-else-if="tempData.direction_ratio == -1">
                                <p>价格涨过上线价：ok开空，火币开多; 价格跌破下线价：ok开多，火币开空</p>
                            </div>
                        </div>
                        <el-form label-width="90px" >
                            <el-form-item label="上线价格" style="margin-bottom: 0;">
                                <el-input v-model="editParam.upPrice"></el-input>
                                <span class="temp-board_size">{{positionJude(tempData.direction_ratio)}}</span>
                            </el-form-item>
                            <el-form-item class="temp-board_st" style="margin-bottom: 0;">
                                <i class="el-icon-sort type_change_btn" v-if="tempData.direction_ratio == 1" @click="tempHandleEvent(-1)" 
                                title="反向"></i>
                                <i class="el-icon-sort type_change_btn" v-else-if="tempData.direction_ratio == -1" @click="tempHandleEvent(1)" 
                                title="反向"></i>
                            </el-form-item>
                            <el-form-item label="下线价格">
                                <el-input v-model="editParam.downPrice" ></el-input>
                                <span class="temp-board_size" v-if="tempData.direction_ratio == 1">ok开空，火币开多</span>
                                <span class="temp-board_size" v-else-if="tempData.direction_ratio == -1">ok开多，火币开空</span>
                            </el-form-item>
                            <el-form-item label="ok偏移量(%)">
                                <el-input v-model="editParam.offsetPercentage" placeholder="0~100之间的数,单位为%"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="temp-handle_error">{{editErr}}</div>
                        <div class="handle-board_btn">
                            <el-button class="btn__style_white" @click="submitEdit">确认</el-button>
                            <el-button class="btn__style_white" @click="editFlag = false">取消</el-button>
                        </div>
                    </div>
                </div>
                <div class="temp-strategy_box_item float-right">
                    <el-button class="btn__style" @click="handleStatus('1')">手动交易</el-button>
                    <el-button class="btn__style" @click="handleStatus('0')">策略跟随</el-button>
                    <el-button class="btn__style" @click="handleStatus('2')">网格交易</el-button>
                </div>
                
            </div>
            <div class="temp-strategy_box">
                <div class="temp-strategy_box_item">
                    <span>临时策略(线上测试)</span>
                </div>
                <div class="temp-strategy_box_item">
                    <span class="strategy_box_status" v-if="statusJurge"
                    :style="{'color': statusJurge.color}">{{statusJurge.name}}</span>
                </div>
            </div>
            <div class="temp-strategy_detail">
                <table v-if="tempData">
                    <thead>
                        <tr>
                            <th class="text_align_left"></th>
                            <th>权益币数</th>
                            <th>盈亏币数</th>
                            <th>收益率</th>
                            <th>成本</th>
                            <th>多头持仓</th>
                            <th>空头持仓</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text_align_left">okex</td>
                            <td>{{tempData.okexeq}}</td>
                            <td>{{tempData.ok_pnl}}</td>
                            <td>{{tempData.ok_pnl_ratio}}%</td>
                            <td>{{tempData.ok_avg_cost}}</td>
                            <td style="color: #db5634">{{tempData.ok_position[0]}}</td>
                            <td style="color: #0b8a7b;">{{tempData.ok_position[1]}}</td>
                        </tr>
                        <tr>
                            <td class="text_align_left">huobi</td>
                            <td>{{tempData.huobieq}}</td>
                            <td>{{tempData.hb_pnl}}</td>
                            <td>{{tempData.hb_pnl_ratio}}%</td>
                            <td>{{tempData.hb_avg_cost}}</td>
                            <td style="color: #db5634">{{tempData.hb_position[0]}}</td>
                            <td style="color: #0b8a7b;">{{tempData.hb_position[1]}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="temp-strategy_record">
                <el-table style="width: 100%" v-if="tempData" :data="tempData.records"
                stripe>
                    <el-table-column v-for="(item, index) in tradeColumn" :key="'t_'+index" 
                    :prop="item.key"
                    :label="item.name"> 

                    </el-table-column>
                </el-table>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import Header from "@/components/header/Header.vue";
import { get } from "@/api/index";
import { mapState } from "vuex";

export default {
    components: {
        Header
    },
    data: function () {
        return {
            value: true,
            status: '',
            showFlag: false,
            openType: '1',
            openNum: '',
            positionData: {},
            timer: '',
            tradeColumn: [
                { name: '币对', key: 'instrument_id' },
                { name: '委托数量', key: 'amount' },
                { name: 'okex平多', key: 'ok_type' },
                { name: 'huobi平空', key: 'hb_type'},
                { name: 'okex价格', key: 'ok_price' },
                { name: 'huobi价格', key: 'hb_price' },
                { name: 'okex数量', key: 'ok_amount' },
                { name: 'huobi数量', key: 'hb_amount' },
                { name: '交易时间', key: 'createtime' }
            ],
            tradeData: '',
            editFlag: false,
            editParam: {
                upPrice: '',
                downPrice: '',
                offsetPercentage: ''

            },
            editErr: '',
            socketObj: '',
            tempData: '',
        }
    },
    mounted() {
        this.initWebSocket();
    },
    computed: {
        ...mapState([
            'tempSocket'
        ]),
        // 状态判断
        statusJurge: function () {

            if (!this.tempData) return;

            if (String(this.tempData.status) == '1') {// 手动
                return {
                    "name": "手动模式",
                    "color": "#0B8A7B",
                }
            } else if (String(this.tempData.status) == '0') {// 程序 
                return {
                    "name": "策略跟随模式",
                    "color": "#0B8A7B"
                }
            } else if (String(this.tempData.status)  == '2') {// 半自动
                return {
                    "name": "网格模式",
                    "color": "#0B8A7B"
                }
            }
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        
    },
    methods: {

        // 获取临时策略
        getTempStrategy() {
            var url = this.$url_temp + "/get/status";
            get(url).then(res => {
                if (res.code == 200) {
                    this.status = res.state;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 200
                    })
                }
            })
        },

        // 手动 程序 事件
        handleStatus(flag) {
            var url = this.$url_temp + '/change/status';
            var showWord;

            if (flag == '2') {
                showWord = '是否已重新设置半自动参数?';
            } else {
                showWord = '是否确认操作?';
            }


            this.$confirm(showWord, '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                var param = {
                    "state": flag
                };
                get(url, param).then(res => {
                    if (res.code === 200) {
                        this.getTempStrategy();
                        this.$notify.info({
                            message: res.msg,
                            title: '提示',
                            offset: 200
                        })
                    } else {
                        this.$notify.error({
                            message: res.msg,
                            title:'提示',
                            offset: 200
                        })
                    }
                })
            }).catch(() => {

            })
        },

        // 处理事件
        handleEvent() {
            this.showFlag = true;
        },

        // 提交开仓
        submitOpen() {
            var url = this.$url_temp + "/manual/trading";
            var param = {
                "type": this.openType,
                "number": this.openNum
            };

            get(url, param).then(res => {
                if (res.code === 200) {
                    // this.$notify.info({
                    //     message: res.msg,
                    //     title: "提示",
                    //     offset: 200
                    // })
                    this.showFlag = false;
                    this.getPositionData();
                    this.getTempStrategy()
                } else {
                    this.$notify.error({
                        message: res.msg,
                        title: "提示",
                        offset: 200
                    })
                }
            })
        },

        // 获取持仓数据
        getPositionData() {
            var url = this.$url_temp + '/get/position';
            get(url).then(res => {
                if (res.code === 200) {
                    this.positionData = res.data;
                } else {
                    this.$notify.error({
                        message: res.msg,
                        title: "提示",
                        offset: 200
                    })
                }
            })
        },

        // 获取交易数据
        getTradeData() {
            var url = this.$url_temp + '/get/transaction/records';
            get(url).then(res => {
                if (res.code === 200) {
                    this.tradeData = res.data;
                }
            })
        },

        // 编辑显示
        editEvent() {
            var url = this.$url_temp + "/get/set/data";
            get(url).then(res => {
                if (res.code === 200) {
                    this.editParam.upPrice = res.data.up_price;
                    this.editParam.downPrice = res.data.down_price;
                    this.editParam.offsetPercentage = res.data.offset_percentage;
                    this.editFlag = true;
                } else {
                    this.$notify.error({
                        message: res.msg,
                        title: '提示',
                        offset: 200
                    })
                }
            })
        },

        submitEdit() {
            console.log(this.editParam);
            if (JSON.stringify(this.editParam) == "{}") {
                this.editErr = "参数不能为空";
                return;
            }

            if (Number(this.editParam['offsetPercentage']) < 0 || Number(this.editParam['offsetPercentage']) > 100) {
                this.editErr = "请填入0~100之间的数!";
                return;
            }

            this.editErr = "";
            var url = this.$url_temp + "/set/data";
            

            get(url, this.editParam).then(res => {
                if (res.code === 200) {
                    this.$notify.info({
                        message: res.msg,
                        title: '提示',
                        offset:200
                    });
                    this.editFlag = false;
                } else {
                    this.editErr = res.msg;
                }
            })

            
        },

        // websocket 初始化
        initWebSocket() {
            if (!this.tempSocket.skt) {
                // 107.149.104.7
                this.tempSocket.skt = new WebSocket("ws://107.149.104.7:8026/web/socket");
                console.log('socket conncet successfully');
            } 

            // this.socketObj.
            this.tempSocket.skt.onopen = this.socketOpen;
            this.tempSocket.skt.onmessage = this.getMsg;
            this.tempSocket.skt.onclose = this.socketClose;
        },

        getMsg(res) {
            var data = JSON.parse(res.data);
            this.tempData = data;
        },

        // send 函数
        socketOpen() {

        },

        // socket 关闭函数
        socketClose(e) {
            console.log("webSocket connect close ", e);
        },

        // 设置 方向
        tempHandleEvent(tag) {
            console.log(typeof tag, tag);
            var url = "http://107.149.104.7:8026/set/direction/ratio";
            var param = {
                type: tag
            };
            get(url, param).then(res => {
                if (res.code === 200) {
                    this.$notify.info({
                        message: res.info,
                        title: '提示',
                        offset: 200
                    })
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 200
                    })
                }
            })
        },

        // 开仓方向
        positionJude(flag) {
            if (flag == 1) {
                return 'ok开多，火币开空';
            } else if (flag == -1) {
                return 'ok开空，火币开多';
            }
        }
    }
}
</script>

<style lang="scss">
.temp-strategy {
    color: #818182;
    .el-button:focus {
        // background-color: initial;
        border-color: transparent;
    }
    .el-main {
        background-color: transparent;
        margin: 0 20px;
        margin-top: 20px;

        .temp-strategy_detail {
            background-color: #272829;
            padding: 0 10px;


            .temp-strategy_box_item2 {
                margin-top: 49px;
            }

            .temp-strategy_box_item1 {
                width: 18%;
                text-align: right;
                margin-top: 45px;
                .temp-handle-board {
                    padding: 20px;
                    position: absolute;
                    background-color: #fff;
                    border-radius: 5px;
                    z-index: 1; 
                }

                .el-button:focus {
                    background-color: #333;
                }
            }

            .strategy_box_status {
                padding: 2px 5px;
                border-radius: 3px;
                color: #fff;
                text-align: center;
            }

            .text_align_left {
                text-align: left;
            }
            table {
                width: 50%;
                margin: 0 auto;
            }
            table th {
                padding: 5px 10px;
                font-size: 12px;
                padding-left: 0;
            }
            table td {
                padding: 5px 5px 5px 0;
            }
        }

        .temp-strategy_box {
            padding: 10px;
            background-color: #272829;
            text-align: left;
            .strategy_box_status {
                padding: 2px 5px;
                border-radius: 3px;
                color: #fff;
                text-align: center;
            }
        }
        .temp-strategy_box_item {
            text-align: left;
            margin-left: 10px;
            .el-button:focus {
                background-color: #333333;
            }
        }
        .temp-strategy_title {
            text-align: left;
            padding: 10px;
            background-color: #1e1e1e;
            position: relative;
        }
        .temp-strategy_box_item {
            // margin: 0 10px;
            display: inline-block;
            vertical-align: middle;
            // width: 20%;
            .temp-handle-board {
                padding: 20px;
                position: absolute;
                background-color: #fff;
                border-radius: 5px;
                z-index: 1; 
                right: 0;
                .el-form {
                    .el-input {
                        width: 50%;
                    }
                    .temp-board_size {
                        font-size: 12px;
                        margin-left: 5px;
                    }

                    .temp-board_st {
                        .el-form-item__content {
                            text-align: right;
                            padding-right: 80px;
                            line-height: 16px;
                        }
                        .type_change_btn {
                            font-size: 16px;
                        }
                        .type_change_btn:hover {
                            color: #409EFF;
                            cursor: pointer;
                        }
                    }
                }
                .temp-handle_tip {
                    padding: 5px 10px;
                    font-size: 12px;
                    margin-bottom: 10px;
                }

                .temp-handle_der_item {
                    font-size: 12px;
                    .text_color {
                        color: #e83b0f;
                    }
                }

                .el-button:focus {
                    background-color: #ecf5ff;
                }
            }

            .strategy_box_item_span {
                margin-left: 10px;
            }

            .handle-board_btn {
                text-align: right;
            }
            .el-form-item {
                margin-bottom: 15px;
            }

            .el-dropdown {
                .el-button:focus{
                    background-color: #333333;
                }
            }

            .temp-handle_error {
                color: #e83b0f;
                padding-bottom: 10px;
                text-align: right;
                font-size: 12px;
            }
        }

        .el-switch__label {
            color: #818182;
        }
        .el-switch__label.is-active {
            color: #409EFF;
        }

        .temp-strategy_record {
            font-size: 12px;
            margin-top: 30px;
            .el-table {
                font-size: 12px;
                thead{
                    th {
                        background-color: #1e1e1e;
                    }
                }
            }
            .el-table th, .el-table tr {
                background-color: #272829;
            }
            .el-table td, .el-table th.is-leaf {
                border-bottom: 1px solid #363738;
            }
            .el-table--enable-row-hover .el-table__body tr:hover>td {
                background-color: #1e1e1e;
                color: #999999;
            }
            .el-table--striped .el-table__body tr.el-table__row--striped td {
                background: #252425;
            }
        }

        .el-form-item__label {
            color: #a8a7a9;
        }
    }    
}
</style>
